import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { _serverUrl2 } from "../../../config";
import { MyMap } from "../../Map/View/MyMap";
import ProjectSideBar from "./ProjectSideBar";

import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { addPolygonsWithColor, tempLayer } from "../../../Utils/MapUtils";
import { zoomToFeatureByGeojson } from "../../Map/Layers/TempLayer";

const editedLayer = new VectorLayer({
  source: new VectorSource({
    wrapX: false,
  }),
});

export default function BolgesiOlmayan() {
  const [tabloVeri, setTabloVeri] = useState([]);
  const projeID = useParams().id;

  const getTabloVeri = async () => {
    await axios
      .get(_serverUrl2 + "/Projects/BolgesiOlmayanGorevler/")
      .then((res) => {
        console.log(res.data.rows, "res1212");
        setTabloVeri(res.data.rows);
      })
      .catch((error) => {
        console.log(error, "error-gettabloveri");
      });
  };

  const getVeri = useCallback(async () => {
    await axios.get(_serverUrl2 + "/projects/getAreas/" + projeID).then((res) => {
      console.log(res.data.rows, "resdatarowsareaabefea");
      tempLayer.getSource().clear();
      res.data.rows.map((d) => {
        return addPolygonsWithColor(d.geojson, d.color, d.bolge_adi, d.id);
      });
    });
  }, [projeID]);

  useEffect(() => {
    getTabloVeri();

    getVeri();
    //MyMap.addInteraction(modify)
    MyMap.addLayer(editedLayer);
    MyMap.addLayer(tempLayer);
    return () => {
      MyMap.removeLayer(tempLayer);
      MyMap.removeLayer(editedLayer);
      tempLayer.getSource().clear();
    };
  }, [getVeri]);

  return (
    <>
      <div className="row">
        <div className="col-12" style={{ fontSize: "12px" }}>
          <ProjectSideBar page={"4"} />
        </div>

        <div
          className="col-12  p-2 d-flex justify-content-center content"
          style={{ fontSize: "24px", borderRadius: "20px", width: "70%", marginLeft: "15%", marginBottom: "2%" }}
        >
          <b>Bölgesi Olmayan Binalar</b>{" "}
        </div>

        <div className="col-sm-12" style={{ height: "650px", overflowY: "auto" }}>
          <table className="table table-sm table-bordered table-striped">
            <thead style={{ fontSize: "14px", position: "sticky", top: "0", zIndex: "1", backgroundColor: "gray" }}>
              <tr style={{ backgroundColor: "gray" }}>
                <th>Konum</th>
                <th>Maks Kimlik Numarası</th>
                <th>Görev Durumu</th>
              </tr>
            </thead>
            <tbody>
              {tabloVeri.map((d, i) => {
                return (
                  <tr key={i}>
                    <td style={{ borderLeft: "3px solid rgb(160, 202, 140)" }} onClick={() => zoomToFeatureByGeojson(d.geojson)}>
                      <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                    </td>
                    <td style={{ fontSize: "14px" }}>{d.maks_kn}</td>
                    <td style={{ fontSize: "14px" }}>{d.gorev_durum}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
